import { QuadTreeConfig } from "js-quadtree/dist/types"

// Initial value of tooltip provider

export const initialState = {
  data: [],
  coords: {
    x: 0,
    y: 0
  },
  containerSize: {
    widthStartsAt: 0,
    width: 0,
    height: 0
  }
}

// Default config for QuadTree

export const qtDefaultConfig: QuadTreeConfig = {
  // Specify the maximum amount of point per node (default: 4)
  capacity: 4,

  // Specify if the quadtree has to remove subnodes if they are empty (default: false).
  removeEmptyNodes: true,

  // Specify the maximum depth of the quadtree. -1 for no limit (default: -1).
  maximumDepth: 5,

  // Specify a custom method to compare point for removal (default: (point1, point2) => point1.x === point2.x && point1.y === point2.y).
   arePointsEqual: (point1, point2) => point1.data.qtId === point2.data.qtId
}

export const initialTooltipDataState = {
  insert: () => null,
  getTree: () => null,
  getAllPoints: () => null,
  remove: () => null,
  clear: () => null,
  queryCirclePoints: () => null,
  hide: () => null,
  lastUpdatedAt: null
}
